<template>
    <Button
        :icon="iconClass"
        :loading="loading"
        :disabled="disabled || loading"
        :severity="severity"
        :size="size"
        :outlined="outlined"
        :pt="passThrough"
        :fluid="fullWidth"
        v-bind="linkProps"
    >
        <slot></slot>
    </Button>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import Button from 'primevue/button'
import type { ButtonProps } from 'primevue'

const props = defineProps({
    href: String,
    to: [String, Object],
    disabled: Boolean,
    loading: Boolean,
    icon: Boolean,
    arrow: Boolean,
    large: Boolean,
    small: Boolean,
    opaq: Boolean,
    outlined: Boolean,
    color: {
        type: String,
        default: 'primary', // maps to PrimeVue 'severity'
    },
    fullWidth: Boolean,
})

const COLOR_MAP: Record<string, ButtonProps['severity']> = {
    error: 'danger',
    succes: 'success',
    warning: 'warn',
    info: 'info',
    midnight: 'info',
    black: 'contrast',
    gray: 'contrast',
}

const severity = computed(() => {
    if (props.opaq && props.color === 'primary') {
        return 'secondary'
    }

    return COLOR_MAP[props.color]
})

const outlined = computed(() => {
    return props.outlined || props.opaq && severity.value === 'contrast'
})

const size = computed(() => {
    if (props.large) return 'large'
    if (props.small) return 'small'
    return undefined
})

const iconClass = computed(() => (props.icon ? 'pi pi-check' : undefined)) // Customize this

const linkProps = computed(() => {
    if (props.to) return { to: props.to, as: 'router-link' }
    if (props.href) return { href: props.href, as: 'a', target: '_blank', rel: 'noopener noreferrer' }
    return {}
})

const passThrough = {
    root: {
        class: [
            props.arrow ? 'has-arrow' : '',
        ],
    },
}
</script>
